import Cookies from "js-cookie";
import { logError, logInfo } from "@common/Logger";
import { guid } from "@common/Guid";
import { connection } from "../../../_Workflows/connection";

let subscribers: any[] = [];
const headers: any[] = [];

function initializeHeaders() 
{
    for (const name in Cookies.get()) 
    {
        if (name.indexOf("AppRT_Header_") == 0) 
        {
            const header = JSON.parse(Cookies.get(name));
            headers.push(header);
        }
    }
}

function process(data: any)
{
    if (!Array.isArray(data))
    {
        process([data]);
        return;
    }

    for (const message of data) {
        if (message) {
            const workflow = getHeader(message, "Workflow");
            logInfo(`${workflow}: ${message.Module}.${message.Action}`);

            for (const fn of subscribers) {
                fn(message);
            }
        }
        else {
            logInfo("Null message recieved");
        }
    }
}

function applyPropertiesAndHeaders(message: any) {
    message.MessageId = guid();
    message.ConnectionId = connection.connectionId;
    message.SessionId = Cookies.get("AppRT.SessionId");
    message.SenderId = "AppRT.Web";

    logInfo(message);

    if (!message.Headers) {
        message.Headers = [];
    }

    if (headers.length > 0) {
        for (const header of headers) {
            const exist = (message.Headers as any[]).some(a => a.Name == header.Name && a.Value == header.Value);

            if (!exist) {
                message.Headers.push(header);
            }
        }
    }

    message.Headers.push({ Name: "Context", Value: window.location.hash.replace("#", "") });
    message.Headers.push({ Name: "Url", Value: window.location.href });

    return message;
}

export function getHeader(message: any, headerName: string) {
    if (!message || !message.Headers) {
        return null;
    }
    const header = message.Headers.find((a: any) => a.Name == headerName);
    return header ? header.Value : null;
}


async function ensureConnected()
{
    // already good
    if (connection.state === "Connected")
        return

    // bootstrap is starting it → just wait
    if (connection.state === "Connecting")
    {
        await new Promise<void>((resolve, reject) =>
        {
            const started = Date.now()

            const timer = setInterval(() =>
            {
                if (connection.state === "Connected")
                {
                    clearInterval(timer)
                    resolve()
                }

                if (connection.state === "Disconnected")
                {
                    clearInterval(timer)
                    reject("SignalR disconnected while connecting")
                }

                if (Date.now() - started > 5000)
                {
                    clearInterval(timer)
                    reject("SignalR connect timeout")
                }

            }, 20)
        })

        return
    }
}


export async function send(module: string, action: string, data: any = null)
{
    await ensureConnected()

    const msg = applyPropertiesAndHeaders({
        Module: module,
        Action: action,
        Data: data
    });

    console.log("[RT] send()", {
        module,
        action,
        state: connection.state
    });

    logInfo(`Sending message: ${module}.${action}`);
    logInfo(msg);
    connection.send("process", msg);
}


export function subscribeModule(module: string, actions: { [propName: string]: any }) {
    const handler = (message: any) => {
        if (message.Module === module) {
            if (typeof actions[message.Action] === "function") {
                actions[message.Action](message.Data);
            }
            else if (typeof actions["_CatchAll"] === "function") {
                actions._CatchAll(message);
            }
            else {
                logError(`There is no '${message.Action}' action in the '${message.Module}'`);
            }
        }
    }
    subscribers.push(handler);
    return handler;
}


export function unsubscribe(handler: any) {
    subscribers = subscribers.filter(a => a != handler);
}

export function appRT(connection: any)
{
    connection.on("process", (data: any) =>
    {
        logInfo(data);

        if (Array.isArray(data))
        {
            process(data)      
        }
        else
        {
            process([data]);
        }
    });

    logInfo("Started");
    initializeHeaders();
    Cookies.set("AppRT.ConnectionId", connection.connectionId);
}